import { refs } from './refs';

export function renderTask(tasks) {
  const markup = tasks
    .map(
      ({ title, descr, id }) => `<li class="task-list-item" data-id="${id}">
    <button class="task-list-item-btn">Delete</button>
    <h3>${title}</h3>
    <p>${descr}</p>
</li>`
    )
    .join('');

  refs.taskList.innerHTML = markup;
}
